import { ReactNode } from 'react';
import { Icon } from '@tcc/crate';
import styles from './cardAndPreview.css';
import previewNavStyles from './PreviewNavigationCard.css';
import PreviewCard from './PreviewCard';

export interface PreviewNavigationCardProps {
  children: ReactNode;
  errorMessage?: string;
  isLoading?: boolean;
  onLeftClick?: (() => void);
  onRightClick?: (() => void);
  testId?: string;
}

export const PreviewNavigationCard = ({
  children,
  errorMessage,
  isLoading,
  onLeftClick,
  onRightClick,
  testId,
}: PreviewNavigationCardProps) => (
  <PreviewCard
    errorMessage={errorMessage}
    isLoading={isLoading}
    testId={testId}
  >
    <div className={`${styles.spacedRow} ${previewNavStyles.noSelect}`}>
      <div
        className={`${[
          previewNavStyles.arrow,
          previewNavStyles.leftArrow,
          !onLeftClick ? previewNavStyles.disabled : '',
        ].join(' ')}`}
        data-test-id="dmb-preview-left-arrow"
        onClick={onLeftClick}
        role="button"
        tabIndex={0}
      >
        <Icon glyph={Icon.set.ARROW_RIGHT} />
      </div>

      {children}

      <div
        className={`${previewNavStyles.arrow} ${
          !onRightClick ? previewNavStyles.disabled : ''
        }`}
        data-test-id="dmb-preview-right-arrow"
        onClick={onRightClick}
        role="button"
        tabIndex={0}
      >
        <Icon glyph={Icon.set.ARROW_RIGHT} />
      </div>
    </div>
  </PreviewCard>
);



export default PreviewNavigationCard;
